export default "https://legacy.eskolare-development.com/images/loading.png";